import { AssetSvg } from '@/components/foundation/Svg'
import { AutocompleteResult } from '@common/types/AutocompleteResult'
import styles from '@/components/ui/Autocomplete/NewAutocompleteInput.scss'

type IconByResultType = {
  address: string
  poi: string
  boundary: string
  area: string
  line: string
  school: string
}

const iconByResult: IconByResultType = {
  address: 'assets/Location.svg',
  poi: 'assets/ServicePoint.svg',
  boundary: 'assets/Boundary.svg',
  area: 'assets/ModeBus.svg',
  line: 'assets/ModeBus.svg',
  school: 'assets/SchoolWithoutBg.svg',
}

function renderAutocompleteIcon(
  result: AutocompleteResult & {
    def: string
  },
) {
  return <AssetSvg className={styles.icon} name={iconByResult[result.def as keyof IconByResultType]} />
}

__OVERRIDE(renderAutocompleteIcon)
